import { Env } from '@stencil/core';

const resources = {
  local: {
    webcometUrl: 'https://webcomet.test',
  },
  production: {
    webcometUrl: 'https://app.webcomet.io',
  },
  staging: {
    webcometUrl: 'https://dev-app.webcomet.io',
  },
};

export const apis = resources[Env.apiEnv];
